import { useLocalStorage } from "@mantine/hooks";
import type { EnergyPriceUnits } from "../RevenueMonitoring.types";

function useLsEnergyPriceUnit() {
  const [energyPriceUnit, setEnergyPriceUnit] =
    useLocalStorage<EnergyPriceUnits>({
      key: "EM_energyUnit",
      defaultValue: "ct/kWh",
      getInitialValueInEffect: false
    });

  return { energyPriceUnit, setEnergyPriceUnit };
}

export { useLsEnergyPriceUnit };
